import { NavbarNotAuth } from "../userNotAuth/components"
import { useParams } from 'react-router-dom'
import axios from "axios"
import { useEffect } from "react"

function DisabledNotificaEmail() {
    const { idEvento, tipo } = useParams()

    useEffect(() => {
        if (tipo === 'email' && idEvento) {//disable notifica email
            const e = 'setEmail'; const h = 'true'
            axios.get(`/setComment/${e}/${h}/${idEvento}`)
        } else
            if (tipo === 'commenti' && idEvento) {//disable comment
                const e = 'setComment'; const h = 'true'
                axios.get(`/setComment/${e}/${h}/${idEvento}`)
            }
    }, [tipo])
    return (<>
        <NavbarNotAuth />
        <div className="mt-5 p-5">
            {tipo === 'email' &&
                <p>
                    Le tue preferenze sono state aggiornate. <br />
                    A partire da questo momento, non riceverai più avvisi email per i nuovi messaggi o le domande degli utenti relative al tuo evento. <br /><hr />
                    Se hai disattivato le notifiche per errore e desideri riattivarle, o se vuoi metterti in contatto con il nostro team, puoi scriverci a: zonaeventiinfo@gmail.com
                </p>
            }
            {tipo === 'commenti' &&
                <p>
                    Le tue preferenze sono state aggiornate. <br />
                    A partire da questo momento, non riceverai più nuovi messaggi relative al tuo evento. <br /><hr />
                    Se hai disattivato la messaggistica per errore e desideri riattivarla, o se vuoi metterti in contatto con il nostro team, puoi scriverci a: zonaeventiinfo@gmail.com
                </p>
            }
        </div>
    </>)
}
export default DisabledNotificaEmail